import imagesReducer from './imagesReducer';

export * from './imagesActions';
export default imagesReducer;